class JWT {
	constructor({ privateKey, publicKey }={}) {
		this.privateKey = privateKey;
		this.publicKey = publicKey;
	}

	parse(token) {
		let [ algo, payload, signature ] = token.split('.');
		// payload is encoded in Base64URL and atob want strict encode in Base64
		// what is changed : "-" become "+" and "_" become "/"
		payload = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
		algo = JSON.parse(atob(algo.replace(/-/g, "+").replace(/_/g, "/")));
		return { algo, payload, signature };
	}
}

let jwt = new JWT();

export default jwt;
